import './App.css';
import Footer from './components/Footer/Footer';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavSlide from './components/Nav-Slide/Nav-Slide';
import { motion } from 'framer-motion';
import Navbar from './components/Navbar/Navbar';
import AboutMain from './components/About/About';
import Services from './components/Services/Services';
import BrandSlider from './components/BrandSlider/BrandSlider';
import HowItWorks from './components/HowItWorks/How';
import Stats from './components/Stats/Stats';
import Testimonial from './components/Testimonial/Testimonial';
import ContactStrip from './components/ContactStrip/ContactStrip';
import ContactUs from './components/ContactPage/Contact';
import AboutPage from './components/About Page/AboutPage';
import FAQ from './components/FAQ/FAQ';

import React, { useState, useEffect } from 'react';
import { IoArrowUpCircle } from "react-icons/io5";

const HomePage = () => {
  return (
    <>
      <NavSlide />
      <motion.div initial={{ opacity: 0, y: 70 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}><AboutMain /></motion.div>
      <motion.div id="services" initial={{ opacity: 0, y: 70 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}><Services /></motion.div>
      <BrandSlider />
      <motion.div id="howitworks" initial={{ opacity: 0, y: 70 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }} ><HowItWorks /></motion.div>
      <Stats />
      <motion.div id="testimonials" initial={{ opacity: 0, y: 70 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}><Testimonial /></motion.div>
      <ContactStrip />
      <FAQ/>
      <Footer />
    </>
  );
};

const ContactPage = () => {
  return (
    <>
      <ContactUs />
      <Footer />
    </>
  );
};
const AboutUs = () => {
  return (
    <>
      <AboutPage />
    </>
  );
}

function App() {

  const [showScrollToTop, setShowScrollToTop] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 300) {
      setShowScrollToTop(true);
    } else {
      setShowScrollToTop(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path='/aboutPage' element={<AboutUs />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>

      {showScrollToTop && (
        <div
          className="scroll-to-top-btn"
          onClick={scrollToTop}
        >
          <IoArrowUpCircle color="#fff" size={35} />
        </div>
      )}
    </>
  );
}

export default App;
